module.exports = __webpack_public_path__ + "static/media/loginBanner.5a57a799.png";